import { useEffect, useRef, useState } from "react";

/**
 * Hook simple para revelar elementos cuando entran al viewport.
 * Devuelve {ref, visible} para usar en JSX:
 *   const { ref, visible } = useReveal();
 *   <div ref={ref} className={visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}>
 */
export function useReveal({ threshold = 0.15, once = true } = {}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    if (once) observer.unobserve(node);
                } else if (!once) {
                    setVisible(false);
                }
            },
            { threshold }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [threshold, once]);

    return { ref, visible };
}
